import { render, staticRenderFns } from "./views.vue?vue&type=template&id=4b6f2be9"
import script from "./views.vue?vue&type=script&lang=js"
export * from "./views.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports